import netcoServer from '../../apis/netcoServer';
import loadingCall from "../helpers/loadingCall";

const userExists= (userName,callBack) => async (dispatch) => {
    callBack(await loadingCall(dispatch, () => netcoServer.newPost('/UserService/userExists', {userName})));
};
export default userExists;
